import { Button, ButtonVariant } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

export type RulebookAttachActionsProps = {
  isAttaching: boolean;
  isSubmitDisabled: boolean;
  submitLabel: string;
  onClose: () => void;
  onSubmit: () => void;
};

const RulebookAttachActions = ({ isAttaching, isSubmitDisabled, submitLabel, onClose, onSubmit }: RulebookAttachActionsProps) => (
  <div className="flex justify-end gap-sm" data-testid="RulebookAttachActions">
    <Button variant={ButtonVariant.OUTLINED} type="button" onClick={onClose} disabled={isAttaching} data-testid="RulebookAttachActions-CancelButton">
      <Trans i18nKey="rulebook:attach.action.cancel" />
    </Button>
    <Button
      variant={ButtonVariant.CONTAINED}
      type="button"
      loading={isAttaching}
      disabled={isSubmitDisabled}
      onClick={onSubmit}
      data-testid="RulebookAttachActions-SubmitButton"
    >
      {submitLabel}
    </Button>
  </div>
);

export default RulebookAttachActions;
